<template>
  <div id="app">
    <router-view />
    <popup-loading v-if="loading"></popup-loading>
  </div>
</template>

<script>
import { PopupLoading } from './components/popup'
import { mapState } from 'vuex'
export default {
  components: {
    PopupLoading
  },
  computed: {
    ...mapState(['loading'])
  }
}
</script>

<style lang="less">
@import './assets/css/public.less';
body {
  background: #000;
  padding: 0;
  margin: 0;
  height: 100vh;
  color: #43D732;
}
#app {
  font-size: 28px;
}
.btn {
  height: 86px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;
  background: #43D732;
  font-size: 32px;
  font-weight: bold;
  // border-radius: 20px;
}
.text-primary {
  color: #43D732;
}
.text-bold {
  font-weight: bold;
}
</style>
